module.exports = __webpack_public_path__ + "img/Super-Steph-SunHero-300-V1.cb5e2fa0.png";